import consumer from "channels/consumer"

export default function(callback) {
  consumer.subscriptions.create(
    { channel: "ProcessPeoplePerformancesChannel" },
    {
      received(data) {
        callback(data.processing, data.status == 'ok')
      }
    }
  )
}

